import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch, ref, PropType } from 'vue'
import UploadFile from '@/components/UploadFile'

const __default__ = { name: 'PotentialBaseMessage' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  data: {
    type: Object as PropType<any>
  }
},
  setup(__props) {

const form = ref()
const props = __props
watch(
  () => props.data,
  (v, prev) => {
    console.log('props.data: ', props.data)
    form.value = props.data
  },
  { immediate: true }
)
// onMounted(() => {
// })

return (_ctx: any,_cache: any) => {
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      ref: "formRef",
      name: "advanced_search",
      model: form.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_card, { title: "基本信息" }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, { label: "客户代码" }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.customerNumber,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.customerNumber) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 50,
                  placeholder: "请输入",
                  view: ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "客户名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.customerName,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.value.customerName) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 50,
                  placeholder: "请输入",
                  view: ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "客户详细地址" }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.customerAddress,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.value.customerAddress) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 50,
                  placeholder: "请输入",
                  view: ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "关联访客计划" }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.visitPlanTitle,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((form.value.visitPlanTitle) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 50,
                  placeholder: "请输入",
                  view: ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "创建人" }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.createByName,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((form.value.createByName) = $event)),
                  valueModifiers: { createByName: true },
                  maxlength: 50,
                  placeholder: "请输入",
                  view: ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "签到时间" }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.signInTime,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((form.value.signInTime) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 50,
                  placeholder: "请输入",
                  view: ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "备注",
              span: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  value: form.value.comment,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((form.value.comment) = $event)),
                  valueModifiers: { trim: true },
                  placeholder: "请输入",
                  view: ""
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_dc_layout_card, { title: "附件信息" }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: "附件",
              span: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(UploadFile), {
                  value: form.value.fileId,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((form.value.fileId) = $event)),
                  valueType: "array",
                  disabled: true
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_cos_footer_button, { hideOk: true })
  ], 64))
}
}

})